import { ActionReducerMap, MetaReducer } from '@ngrx/store'
import { AccountsState, accountsFeatureKey, accountsReducer } from '../accounts'
import { AgentsState, agentsFeatureKey, agentsReducer } from '../agents'
import { BanksState, banksFeatureKey, banksReducer } from '../banks'
import { BusinessTypesState, businessTypesFeatureKey, businessTypesReducer } from '../business-types'
import { buyersGroupsFeatureKey, buyersGroupsReducer, type BuyersGroupsState } from '../buyers-groups'
import { callsFeatureKey, callsReducer, type CallsState } from '../calls'
import { CarriersState, carriersFeatureKey, carriersReducer } from '../carriers'
import { CompanyViewsState, companyViewReducer, companyViewsFeatureKey } from '../company-view/company-view.reducer'
import { ConsigneesState, consigneesFeatureKey, consigneesReducer } from '../consignees'
import { CountriesState, countriesFeatureKey, countriesReducer } from '../countries'
import { TrackingProvidersState, trackingProvidersFeatureKey, trackingProvidersReducer } from '../tracking-providers'
import { PromoTextsState, promoTextsFeatureKey, promoTextsReducer } from '../promo-texts'
import { PackageTrackingsState, packageTrackingsFeatureKey, packageTrackingsReducer } from '../package-trackings'
import { CreditNoteViewsState, creditNoteViewReducer, creditNoteViewsFeatureKey } from '../credit-note-view/credit-notes-view.reducer'
import { CurrenciesState, currenciesFeatureKey, currenciesReducer } from '../currencies'
import { DealViewsState, dealViewReducer, dealViewsFeatureKey } from '../deal-view.reducer'
import { DepartmentsState, departmentsFeatureKey, departmentsReducer } from '../departments'
import { DocumentOverridesState, documentOverridesFeatureKey, documentOverridesReducer } from '../document-overrides'
import { DocumentSetsState, documentSetsFeatureKey, documentSetsReducer } from '../document-sets'
import { DocumentTemplatesState, documentTemplatesFeatureKey, documentTemplatesReducer } from '../document-templates'
import { formulaValuesFeatureKey, formulaValuesReducer, type FormulaValuesState } from '../formula-values'
import { InvoiceViewsState, invoiceViewReducer, invoiceViewsFeatureKey } from '../invoice-view/invoice-view.reducer'
import { ItemTypesState, itemTypesFeatureKey, itemTypesReducer } from '../item-types'
import { LocationsState, locationsFeatureKey, locationsReducer } from '../locations'
import { MeasuresState, measuresFeatureKey, measuresReducer } from '../measures'
import { PackageTypesState, packageTypesFeatureKey, packageTypesReducer } from '../package-types'
import { PaymentMethodsState, paymentMethodsFeatureKey, paymentMethodsReducer } from '../payment-methonds'
import { PrefixesState, prefixesFeatureKey, prefixesReducer } from '../prefixes'
import { SuffixesState, suffixesFeatureKey, suffixesReducer } from '../suffixes'
import { PaymentReferencesState, paymentReferencesFeatureKey, paymentReferencesReducer } from '../payment-references'
import { PricingTermsState, pricingTermsFeatureKey, pricingTermsReducer } from '../pricing-terms'
import { ProductCategoriesState, productCategoriesFeatureKey, productCategoriesReducer } from '../product-categories'
import { ProductSpecificationsState, productSpecificationsFeatureKey, productSpecificationsReducer } from '../product-specifications'
import { ProductTypesState, productTypesFeatureKey, productTypesReducer } from '../product-types'
import { ProductsState, productsFeatureKey, productsReducer } from '../products'
import { ReceiptViewsState, receiptViewReducer, receiptViewsFeatureKey } from '../receipt-view/receipt-view.reducer'
import { SegmentViewsState, segmentViewReducer, segmentViewsFeatureKey } from '../segment-view/segment-view.reducer'
import { ShipmentRatesState, shipmentRatesFeatureKey, shipmentRatesReducer } from '../shipment-rates'
import { TemplatesState, templatesFeatureKey, templatesReducer } from '../templates'
import { UnlocodesState, unlocodeFeaturesKey, unlocodesReducer } from '../unlocodes'
import { UsersState, usersFeatureKey, usersReducer } from '../users'
import { VendorCreditViewsState, vendorCreditViewReducer, vendorCreditViewsFeatureKey } from '../vendor-credit-view/vendor-credit-view.reducer'
import { MatchedOffersViewsState, matchedOffersViewReducer, matchedOffersViewsFeatureKey } from '../matched-offers-view/matched-offers-view.reducer'
import { WeightTypesState, weightTypesFeatureKey, weightTypesReducer } from '../weight-types'
import { WrappingTypesState, wrappingTypesFeatureKey, wrappingTypesReducer } from '../wrapping-types'
import { RecipientTypesState, recipientTypesFeatureKey, recipientTypesReducer } from '../recipient-types'
import { EventsState, eventsFeatureKey, eventsReducer } from '../events'
import { KpiMetricsState, kpiMetricsFeatureKey, kpiMetricsReducer } from '../kpi-metrics'


export interface State {
  [accountsFeatureKey]: AccountsState
  [agentsFeatureKey]: AgentsState
  [banksFeatureKey]: BanksState
  [buyersGroupsFeatureKey]: BuyersGroupsState
  [businessTypesFeatureKey]: BusinessTypesState
  [callsFeatureKey]: CallsState
  [carriersFeatureKey]: CarriersState
  [companyViewsFeatureKey]: CompanyViewsState
  [consigneesFeatureKey]: ConsigneesState
  [countriesFeatureKey]: CountriesState
  [trackingProvidersFeatureKey]: TrackingProvidersState
  [promoTextsFeatureKey]: PromoTextsState
  [packageTrackingsFeatureKey]: PackageTrackingsState
  [creditNoteViewsFeatureKey]: CreditNoteViewsState
  [currenciesFeatureKey]: CurrenciesState
  [dealViewsFeatureKey]: DealViewsState
  [departmentsFeatureKey]: DepartmentsState
  [documentOverridesFeatureKey]: DocumentOverridesState
  [documentSetsFeatureKey]: DocumentSetsState
  [documentTemplatesFeatureKey]: DocumentTemplatesState
  [formulaValuesFeatureKey]: FormulaValuesState
  [invoiceViewsFeatureKey]: InvoiceViewsState
  [itemTypesFeatureKey]: ItemTypesState
  [locationsFeatureKey]: LocationsState
  [measuresFeatureKey]: MeasuresState
  [measuresFeatureKey]: MeasuresState
  [packageTypesFeatureKey]: PackageTypesState
  [paymentMethodsFeatureKey]: PaymentMethodsState
  [paymentReferencesFeatureKey]: PaymentReferencesState
  [prefixesFeatureKey]: PrefixesState
  [suffixesFeatureKey]: SuffixesState
  [pricingTermsFeatureKey]: PricingTermsState
  [productCategoriesFeatureKey]: ProductCategoriesState
  [productsFeatureKey]: ProductsState
  [productSpecificationsFeatureKey]: ProductSpecificationsState
  [productTypesFeatureKey]: ProductTypesState
  [shipmentRatesFeatureKey]: ShipmentRatesState
  [templatesFeatureKey]: TemplatesState
  [receiptViewsFeatureKey]: ReceiptViewsState
  [segmentViewsFeatureKey]: SegmentViewsState
  [usersFeatureKey]: UsersState
  [unlocodeFeaturesKey]: UnlocodesState
  [vendorCreditViewsFeatureKey]: VendorCreditViewsState,
  [matchedOffersViewsFeatureKey]: MatchedOffersViewsState,
  [weightTypesFeatureKey]: WeightTypesState
  [wrappingTypesFeatureKey]: WrappingTypesState
  [recipientTypesFeatureKey]: RecipientTypesState
  [eventsFeatureKey]: EventsState
  [kpiMetricsFeatureKey]: KpiMetricsState
}

export const reducers: ActionReducerMap<State> = {
  [accountsFeatureKey]: accountsReducer,
  [agentsFeatureKey]: agentsReducer,
  [banksFeatureKey]: banksReducer,
  [buyersGroupsFeatureKey]: buyersGroupsReducer,
  [businessTypesFeatureKey]: businessTypesReducer,
  [callsFeatureKey]: callsReducer,
  [carriersFeatureKey]: carriersReducer,
  [companyViewsFeatureKey]: companyViewReducer,
  [consigneesFeatureKey]: consigneesReducer,
  [countriesFeatureKey]: countriesReducer,
  [trackingProvidersFeatureKey]: trackingProvidersReducer,
  [promoTextsFeatureKey]: promoTextsReducer,
  [packageTrackingsFeatureKey]: packageTrackingsReducer,
  [creditNoteViewsFeatureKey]: creditNoteViewReducer,
  [currenciesFeatureKey]: currenciesReducer,
  [dealViewsFeatureKey]: dealViewReducer,
  [departmentsFeatureKey]: departmentsReducer,
  [documentOverridesFeatureKey]: documentOverridesReducer,
  [documentSetsFeatureKey]: documentSetsReducer,
  [documentTemplatesFeatureKey]: documentTemplatesReducer,
  [formulaValuesFeatureKey]: formulaValuesReducer,
  [invoiceViewsFeatureKey]: invoiceViewReducer,
  [itemTypesFeatureKey]: itemTypesReducer,
  [locationsFeatureKey]: locationsReducer,
  [measuresFeatureKey]: measuresReducer,
  [packageTypesFeatureKey]: packageTypesReducer,
  [paymentMethodsFeatureKey]: paymentMethodsReducer,
  [paymentReferencesFeatureKey]: paymentReferencesReducer,
  [prefixesFeatureKey]: prefixesReducer,
  [suffixesFeatureKey]: suffixesReducer,
  [pricingTermsFeatureKey]: pricingTermsReducer,
  [productCategoriesFeatureKey]: productCategoriesReducer,
  [productsFeatureKey]: productsReducer,
  [productSpecificationsFeatureKey]: productSpecificationsReducer,
  [productTypesFeatureKey]: productTypesReducer,
  [receiptViewsFeatureKey]: receiptViewReducer,
  [segmentViewsFeatureKey]: segmentViewReducer,
  [shipmentRatesFeatureKey]: shipmentRatesReducer,
  [templatesFeatureKey]: templatesReducer,
  [usersFeatureKey]: usersReducer,
  [unlocodeFeaturesKey]: unlocodesReducer,
  [vendorCreditViewsFeatureKey]: vendorCreditViewReducer,
  [matchedOffersViewsFeatureKey]: matchedOffersViewReducer,
  [weightTypesFeatureKey]: weightTypesReducer,
  [wrappingTypesFeatureKey]: wrappingTypesReducer,
  [recipientTypesFeatureKey]: recipientTypesReducer,
  [eventsFeatureKey]: eventsReducer,
  [kpiMetricsFeatureKey]: kpiMetricsReducer,
}


export const metaReducers: MetaReducer<State>[] = []
